import React from "react";

export default function TransParentui() {
  return (
    <>
      <svg
        className="desktopsvg"
        width="279"
        height="124"
        viewBox="0 0 279 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_808_1407)">
          <path
            d="M139.241 38.4274L139.5 38.5849L139.759 38.4274L186.559 10.0275C186.559 10.0275 186.559 10.0275 186.559 10.0274C195.879 4.37609 206.789 1.39999 217.7 1.39999C251.224 1.39999 278.5 28.6761 278.5 62.2C278.5 95.7238 251.224 123 217.7 123C206.293 123 195.285 119.826 185.765 113.876L185.761 113.873L139.761 85.7733L139.5 85.6141L139.239 85.7733L93.2393 113.873L93.235 113.876C83.7151 119.826 72.607 123 61.3 123C27.7761 123 0.5 95.7238 0.5 62.2C0.5 28.6761 27.7761 1.39999 61.3 1.39999C72.3105 1.39999 83.1205 4.3759 92.4407 10.0275L139.241 38.4274ZM61.303 30.9H61.3C44.1239 30.9 30.1 44.9238 30.1 62.1C30.1 79.2761 44.1239 93.3 61.3 93.3C78.3697 93.3 92.5 79.6825 92.5 62.2C92.5 44.5159 78.2688 31.0016 61.303 30.9ZM248.9 62.103V62.1C248.9 44.9238 234.876 30.9 217.7 30.9C200.731 30.9 186.5 44.4164 186.5 62.1C186.5 79.5804 200.628 93.3 217.7 93.3C234.879 93.3 248.798 79.2741 248.9 62.103Z"
            stroke="#BBBBBB"
          />
        </g>
        <defs>
          <clipPath id="clip0_808_1407">
            <rect width="279" height="124" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <svg
        className="phonesvg"
        width="183"
        height="77"
        viewBox="0 0 183 77"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M143.825 0.65812L39.1235 0.65812C18.224 0.65812 1.28165 17.6005 1.28165 38.5C1.28165 59.3995 18.224 76.3419 39.1235 76.3419L143.825 76.3419C164.724 76.3419 181.667 59.3995 181.667 38.5C181.667 17.6005 164.724 0.65812 143.825 0.65812ZM39.1235 0C17.8606 0 0.623535 17.237 0.623535 38.5C0.623535 59.763 17.8606 77 39.1235 77L143.825 77C165.088 77 182.325 59.763 182.325 38.5C182.325 17.237 165.088 0 143.825 0L39.1235 0Z"
          fill="#BBBBBB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M157.273 13.8746L88.8217 13.8746C75.2214 13.8746 64.1962 24.8998 64.1962 38.5C64.1962 52.1003 75.2214 63.1255 88.8217 63.1255L157.273 63.1255C170.873 63.1255 181.898 52.1003 181.898 38.5C181.898 24.8998 170.873 13.8746 157.273 13.8746ZM88.8217 13.2165C74.8579 13.2165 63.5381 24.5363 63.5381 38.5C63.5381 52.4638 74.858 63.7836 88.8217 63.7836L157.273 63.7836C171.237 63.7836 182.556 52.4638 182.556 38.5C182.556 24.5363 171.236 13.2165 157.273 13.2165L88.8217 13.2165Z"
          fill="#BBBBBB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M165.829 23.0685L139.074 23.0685C130.392 23.0685 123.355 30.1061 123.355 38.7873C123.355 47.4685 130.392 54.506 139.074 54.506L165.829 54.506C174.51 54.506 181.548 47.4685 181.548 38.7873C181.548 30.1061 174.51 23.0685 165.829 23.0685ZM139.074 22.4104C130.029 22.4104 122.697 29.7426 122.697 38.7873C122.697 47.832 130.029 55.1642 139.074 55.1642L165.829 55.1642C174.874 55.1642 182.206 47.832 182.206 38.7873C182.206 29.7426 174.874 22.4104 165.829 22.4104L139.074 22.4104Z"
          fill="#BBBBBB"
        />
      </svg>
    </>
  );
}
